// 数量のインプット要素と隠しフィールドを取得
const qtyInput = document.querySelector('.qty-input__input');
const hiddenQuantityInput = document.querySelector('input[type="hidden"][name="quantity"]');

// 数量を隠しフィールドに反映させる関数
function updateHiddenQuantity() {
  const quantity = qtyInput.value;
  hiddenQuantityInput.value = quantity;
}

// 数量が変更されたら隠しフィールドを更新
qtyInput.addEventListener('input', updateHiddenQuantity);

// ボタンがクリックされたときは1秒後に隠しフィールドを更新
document.querySelectorAll('.qty-input__btn').forEach(button => {
  button.addEventListener('click', () => {
    setTimeout(updateHiddenQuantity, 1000);
  });
});
